// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"d2c8db30","127":"9cb79f9f","221":"6727dd8d","241":"e0cf950c","292":"062039f8","377":"8ecf6fd4","419":"c9207409","617":"bc924a01","680":"ba932546","683":"60e4227e","763":"40aed641","767":"150b9e74","848":"a4137bb2","944":"7e04f789"}[chunkId] + ".chunk.js";
};